import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { AdminPanelService } from '../../services/admin-panel.service';

@Component({
  selector: 'gig-admin-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    CardModule
],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent implements OnInit {
    public currentUserCount: number = 0;

    constructor(
        private adminService : AdminPanelService
    ) {};

    public ngOnInit(): void {
        void this.loadCurrentUserCount();
    }

    public async loadCurrentUserCount(): Promise<void> {
        const countResp = await this.adminService.getUserCount();
        if (countResp.success) {
            this.currentUserCount = countResp.data || 0;
        }
    }
}
